<template>
    <div class="page">
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight- 116) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <div class="_scroller">
                    <div class="li" v-for="(item, index) in dataSources" :key="index">
                        <div class="address">
                            <div class="consignee">
                                <span>{{item.name}}</span>
                                <span class="phone">{{ item.mobile }}</span>
                            </div>
                            <div class="site-info">
                                {{ item.area }}{{ item.address }}
                            </div>
                        </div>
                        <div class="operation td-fbc">
                            <div class="radio td-fsc" @click="setDerault" :data-index="index" :data-id="item.id">
                                <img v-if="item.is_default == 1" :src="Images.icon_check" />
                                <div v-else class="radio"></div>
                                <span>{{item.is_default == 1 ? '默认地址' : '设为默认地址'}}</span>
                            </div>
                            <div class="td-fsc">
                                <div class="btn td-fcc" @click="goPage" :data-url="'/addAddress?id=' + item.id">编辑</div>
                                <div class="btn btn-del td-fcc" @click="delAddress" :data-index="index" :data-id="item.id">删除</div>
                            </div>
                        </div>
                    </div>
                </div>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
        <div class="footer td-fcc">
            <div class="add-btn td-fcc td-f1" @click="goPage" data-url="/addAddress">添加地址</div>
        </div>
    </div>
</template>
<script type="text/babel">
export default {
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 0,
            limit: 20,
            dataSources: []
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    methods: {
        // 请求地址数据
        async requestData() {
            let url = this.API.user_address_address_list;
            let params = {
                
                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                if (this.page === 1) {
                    dataSourcesTemp = dataList
                    this._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                this.dataSources = dataSourcesTemp
                this.$refs.infinite.finishInfinite(dataList.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 删除地址确认
        delAddress (e) {
            let {index, id} = e.currentTarget.dataset
            this.$dialog.confirm({
                title: '温馨提示',
                message: '删除后无法恢复，您确定要删除地址？',
            })
            .then(() => {
                this.delAddressRequest(index, id)
            })
            .catch(() => {
                this.Message({
                    title: "已取消"
                });
            });
        },
        // 删除地址
        async delAddressRequest (index, id) {
            let url = this.API.user_address_del;
            let params = {
                
                id: id
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources.splice(index, 1)
                this.Message({
                    title: "删除成功"
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 设为默认确认
        setDerault (e) {
            let {index, id} = e.currentTarget.dataset
            if (this.dataSources[index].is_default == 1) return;
            this.$dialog.confirm({
                title: '温馨提示',
                message: '下单时自动将默认地址设为配送地址，您确定要设置为默认地址？',
            })
            .then(() => {
                this.setDeraultRequest(index, id)
            })
            .catch(() => {
                this.Message({
                    title: "已取消"
                });
            });
        },
        // 设为默认
        async setDeraultRequest (index, id) {
            let url = this.API.user_address_set_default;
            let params = {
                
                id: id
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources.forEach((item, key)=>{
                    if (item.is_default == 1) {
                        this.dataSources[key].is_default = 0
                    }
                })
                this.dataSources[index].is_default = 1
                this.Message({
                    title: "设置成功"
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
            
            
        },
        // 跳转
        goPage (e) {
            let {url} = e.currentTarget.dataset
            if (url) this.$router.push(url)
        }
    }
};
</script>

<style lang="less" scoped>
.page{
    padding: 10px 15px;
}
.li{
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 0px rgba(51,51,51,0.10);
    padding: 10px;
    margin-bottom: 10px;
    .consignee{
        color: #333;
        font-size: 15px;
        font-weight: 500;
        .phone{
            padding-left: 20px;
        }
    }
    .site-info{
        font-size: 14px;
        color: #333333;
        padding: 10px 0;
    }
    .operation{
        .radio{
            img{
                width: 15px;
                height: 15px;
                object-fit: contain;
                margin-right: 10px;
            }
            .radio{
                width: 15px;
                height: 15px;
                border: 1px solid #979797;
                border-radius: 50%;
                margin-right: 10px;
                box-sizing: border-box;
            }
            span{
                font-size: 13px;
                font-weight: 500;
                color: #333333;
            }
        }
        .btn{
            width: 62px;
            height: 26px;
            border: 1px solid #7d8bec;
            border-radius: 3px;
            font-size: 13px;
            color: #7181eb;
            margin-left: 10px;
            &.btn-del{
                background: linear-gradient(205deg,#9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
                color: #fff;
            }
        }
    }
}
.footer{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background-color: #fff;
    box-shadow: 0px 0px 5px 0px rgba(51,51,51,0.10);
    .add-btn{
        margin: 5px;
        height: 35px;
        opacity: 1;
        background: linear-gradient(225deg,#9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
    }
}
</style>
